let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ezlyr")).then(() => parcelRequire('6uEie'));